import { render, staticRenderFns } from "./general.vue?vue&type=template&id=5072b256&"
import script from "./general.ts?vue&type=script&lang=js&"
export * from "./general.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports